export default "__VITE_ASSET__ced88416__"